<template>
  <div class="gift-list-box">
    <h4>奖品一览</h4>
    <div class="scroll-box">
      <div v-for="(item,index) in giftListData" :key="index" class="gift-list-item">
        <img :src="item.prizePicture"/>
        <span>{{ item.prizeName }}</span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    giftListData: {
      type: Array,
      default: () => {
      },
    },
  },
  methods: {},
  mounted() {
  },
};
</script>

<style scoped lang="scss">
.gift-list-box {
  box-sizing: border-box;
  width: 100%;
  padding: 29px 36px 33px;
  overflow: hidden;

  h4 {
    font-size: 33px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 45px;
    text-align: center;
    margin-bottom: 54px;
  }

  .scroll-box {
    width: 100%;
    box-sizing: border-box;
    max-height: 543px;
    overflow-y: scroll;
    padding: 4px;
    .gift-list-item {
      width: 100%;
      height: 163px;
      background: #FFFFFF;
      box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
      border-radius: 14px;
      vertical-align: middle;
      margin-bottom: 18px;
      padding: 22px;

      span {
        display: inline-block;
        vertical-align: middle;
        font-size: 29px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
        margin-left: 22px;
      }

      img {
        display: inline-block;
        vertical-align: middle;
        width: 120px;
        height: 120px;
        border-radius: 14px;
        border: 2px solid #EFEFEF;
        padding: 11px;
      }
    }
  }
  .scroll-box::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}
</style>
